import { render, staticRenderFns } from "./LeadAIDetail.vue?vue&type=template&id=208ac7fa&"
import script from "./LeadAIDetail.vue?vue&type=script&lang=js&"
export * from "./LeadAIDetail.vue?vue&type=script&lang=js&"
import style0 from "./LeadAIDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports